export default __webpack_public_path__ + "static/media/W2GIF-3.5df74114.gif";